import { animate, state, style, transition, trigger } from '@angular/animations';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription, firstValueFrom } from 'rxjs';
import { DataNamesDTO } from 'src/app/features/map-features/sections/locations-section/models/DataNamesDTO';
import { LocationDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationDTO';
import { LocationsService } from 'src/app/features/map-features/sections/locations-section/services/Locations.service';
import { IGeoPosDataLocation } from 'src/app/features/map-features/sections/route-section/models/IDataLocation';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { environment } from 'src/environments/environment';
import { MapHelperService } from 'src/services/map-helper.service';
import { ProspectsMapSectionService } from 'src/app/features/map-features/sections/prospects-section/services/prospects-map-section.service';

@Component({
  selector: 'app-prospect-details-popup',
  templateUrl: './prospect-details-popup.component.html',
  styleUrls: ['./prospect-details-popup.component.css'],
  animations: [
        trigger('mostrarHerramientas', [
          state('visible', style({ opacity: 1, height: '*' })),
          state('hidden', style({ opacity: 0, height: '0', overflow: 'hidden', display: 'none' })),
          transition('visible <=> hidden', animate('300ms ease-in-out'))
        ])
      ]
})
export class ProspectDetailsPopupComponent {

  selectedTabIndex: number = 0;
  locationDTO: LocationDTO = {} as LocationDTO;
  locationCategoryShortName: string = "";
  locationCategory: any = null;
  keys: string[] = [];
  values: string[] = [];
  keyNames: DataNamesDTO[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];
  isLoadingImages: boolean = true;
  parentCordX = "";
  parentCordY = "";
  FlyToOnOpen = false;
  FlyToParentOnClose = false;
  UpdateActiveLayer = false;
  Coords: string = "";
  isToolButtonPressed: boolean = false;

  detallesActivo: string[] = [];
  detallesGPS: string[] = [];

  isLoading: boolean = true;
  fullScreen: boolean = false;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  newDialogRef: MatDialogRef<ProspectDetailsPopupComponent>;

  location_details_subscription: Subscription;

  private isDestroyed: boolean = false;
  private activeLayerCategoryName: string = null;

  constructor(
    public dialogRef: MatDialogRef<ProspectDetailsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private mapHelperService: MapHelperService,
    private locationService: LocationsService,
    private notifyService: SwalNotificationService,
    private citronellaActionsService: CitronellaActionsService,
    private notificationsToastService: NotificationsToastService,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private prospectsMapSectionService: ProspectsMapSectionService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    if (!environment.production) console.log("data", data);

    this.locationDTO.identifier = data.identifier != null ? data.identifier : '';
    this.parentCordX = data.parentCoordX;
    this.parentCordY = data.parentCoordY;
    this.FlyToOnOpen = data.FlyToOnOpen != null ? data.FlyToOnOpen : false;
    this.FlyToParentOnClose = data.FlyToParentOnClose != null ? data.FlyToParentOnClose : false;
    this.UpdateActiveLayer = data.UpdateActiveLayer != null ? data.UpdateActiveLayer : false;

    this.GetLocation();
  }

  ngOnInit(): void {
    if (!!this.data.routeSheetLocation && this.data.routeSheetLocation.noOrder == 1) {
      // this.routeSheetUtilService.setRouteFromFirstLocationToParent(this.data.routeSheetLocation);
    }


  }

  ngOnDestroy(): void {
    this.isDestroyed = true;

    if (this.location_details_subscription)
      this.location_details_subscription.unsubscribe();

    if (this.newDialogRef)
      this.newDialogRef.close();

    // this.routeSheetUtilService.clearRouteToPointLayer();
    if (!!this.parentCordX && !!this.parentCordY && this.FlyToParentOnClose) {
      this.mapHelperService.FlyToCamera(this.parentCordY, this.parentCordX, "15");
    }

    if (this.UpdateActiveLayer) {
      this.clearActiveLayer();
    }
  }

  GetLocation() {
    this.isLoading = true;
    this.location_details_subscription = this.locationService.getByIdentifier(this.locationDTO.identifier).subscribe({
      next: async (data: EstatusJSON) => {
        if (this.isDestroyed) {
          return;
        }
        if (data.isSuccess == true && data.result != null) {
          var properties = data.result;
          if (!environment.production) console.log("related Data", properties);
          await this.setDetailsData(properties);
          this.isLoading = false;
        } else {
          Sentry.captureMessage('ProspectDetailsPopup.GetLocation: datos no disponibles', { level: 'warning', extra: { identifier: this.locationDTO.identifier, response: data } });
          this.isLoading = false;
          this.notifyService.message(
            "Se están cargando los detalles. Inténtelo de nuevo más tarde.",
          );
          if (this.location_details_subscription)
            this.location_details_subscription.unsubscribe();
          this.dialogRef.close();
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener locacion por identificador (popup general)', error);
        if (this.isDestroyed) {
          return;
        }
        this.isLoading = false;
        this.notifyService.message("Error al cargar los detalles.");
        if (this.location_details_subscription)
          this.location_details_subscription.unsubscribe();
        this.dialogRef.close();
      }
    });
  }

  reloadDetails() {
    if (this.location_details_subscription)
      this.location_details_subscription.unsubscribe();
    this.GetLocation();
  }

  //recarga el detalle tras editar, y fuerza la recarga de la lista y la capa del panel de prospectos
  onLocationUpdated() {
    this.reloadDetails();
    this.prospectsMapSectionService.notifyProspectDataChanged();
  }

  async setDetailsData(properties: any) {
    this.locationDTO = {
      identifier: properties.identifier,
      description: properties.description,
      lastVoltaje: properties.lastVoltage,
      batteryPercent: properties.batteryPercent,
      gpsStatus: properties.lastGPSStatus,
      canLock: properties.canLock,
      lastUpdate: properties.lastUpdate,
      activeType: properties.Tipo,
      id: properties.id,
      statusVehiculo: properties.statusVehiculo,
      idLocationCategory: properties.idLocationCategory,
      locationCategory: properties.locationCategory,
      icon: properties.icon,
      panelIcon: properties.icon,
      cordsY: properties.cordsY,
      cordsX: properties.cordsX,
      alias: properties.alias,
      categoryStatus: properties.categoryStatus,
      idLocationCategoryStatus: properties.idLocationCategoryStatus ?? 0,
      group: properties.group,
      subGroup: properties.subGroup,

      guid: '',
      color: '',
      data: [],
      counts: 0,
      isFullyAvailable: true,

      statusFlags: properties.statusFlags ? properties.statusFlags : [],
      flagTypes: properties.flagTypes ? properties.flagTypes : [],
    }

    if (this.isDestroyed) {
      return;
    }

    if (this.UpdateActiveLayer) {
      this.setActiveLayer();
    }

    // Obtener y asignar el nombre real de la categoría
    try {
      const categories = JSON.parse(this.localStorageService.getListaCategorias());
      if (categories) {
        const category = categories.find((cat: any) => cat.id === this.locationDTO.idLocationCategory);
        this.locationCategory = category ? category : null;
        this.locationCategoryShortName = category ? category.shortName : '';
      }
    } catch (error) {
      console.error("Error al obtener el nombre real de la categoría", error);
    }

    if (!environment.production) console.log("SETDATA", properties);
    this.arrayMaster = Object.entries(properties.data);
    this.keys = [];
    this.values = [];
    this.arrayMaster.forEach((element) => {
      var obe: IGeoPosDataLocation;
      obe = JSON.parse(JSON.stringify(element[1]));
      this.keys.push(obe.key);
      this.values.push(obe.value);
    });

    if(!this.locationDTO.description || this.locationDTO.description === '') {
      const prospectDescritionKeyI = this.keys.findIndex(k => k === 'nom_estab');
      if (prospectDescritionKeyI !== -1) {
        this.locationDTO.description = this.values[prospectDescritionKeyI];
      } else {
        this.locationDTO.description = this.locationDTO.identifier;
      }
    }

    //Crea arrays de detalles del activo
    this.detallesActivo = this.keys.filter((item) => !item.includes("GPS"));
    // this.detallesActivo.sort();
    //Crea arrays de detalles del GPS
    this.detallesGPS = this.keys.filter((item) => item.includes("GPS"));
    // this.detallesGPS.sort();

    if (!environment.production) console.log("detalles", this.keys, this.detallesActivo, this.detallesGPS);

    // Hacer ambas llamadas en paralelo
    // const [keyNamesResult, imagesResult] = await Promise.all([
    //   firstValueFrom(this.locationService.getDataNames(this.keys)),
    //   this.citronellaActionsService.GetExternalImages(this.locationDTO.idLocationCategory, this.locationDTO.identifier),
    // ]);


    const keyNamesResult = await firstValueFrom(this.locationService.getDataNames(this.keys.concat([this.locationDTO.locationCategory])));

    if (this.isDestroyed) {
      return;
    }

    if (keyNamesResult.isSuccess) {
      this.keyNames = keyNamesResult.result;
    }

    // Cargar imágenes de forma asíncrona sin bloquear
    this.loadImagesAsync();

    if (!!this.locationDTO.cordsX && !!this.locationDTO.cordsY && this.FlyToOnOpen) {
      this.mapHelperService.FlyToCamera(this.locationDTO.cordsY, this.locationDTO.cordsX, "15");
    }
  }

  getUsableName(keyName: string): string {
    const keyNameObject = this.keyNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName) {
    const keyNameObject = this.keyNames.find(
      (item) => item.keyName === keyName
    );
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  CancelButton() {
    this.dialogRef.close();
  }


  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess("Texto copiado al portapapeles", text);
  }

  toggleToolButton() {
    this.isToolButtonPressed = !this.isToolButtonPressed;
  }

  selectTab(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
  }

  openDetailPanel(identifier: any) {
    this.newDialogRef = this.dialog.open(ProspectDetailsPopupComponent, {
      maxWidth: "98vw",
      maxHeight: "92vh",
      autoFocus: false,
      restoreFocus: false,
      hasBackdrop: false,
      disableClose: true,
      data: {
        identifier: identifier,
        parentCoordX: this.locationDTO.cordsX,
        parentCoordY: this.locationDTO.cordsY,
        FlyToOnOpen: true,
        FlyToParentOnClose: true
      }
    });

    this.newDialogRef.afterClosed().subscribe(result => {

    });
  }

  setActiveLayer(): void {
    this.activeLayerCategoryName = this.locationDTO.locationCategory;
    this.mapHelperService.UpdateActiveLocation({
      lat: Number(this.locationDTO.cordsY),
      lng: Number(this.locationDTO.cordsX),
      idntf: this.locationDTO.identifier,
      idLocationCategory: this.locationDTO.idLocationCategory,
      locationCategory: this.locationDTO.locationCategory,
      activeIcon: this.locationDTO.activeIcon
    });
  }

  clearActiveLayer(): void {
    const categoryName = this.activeLayerCategoryName ?? this.locationCategory?.name;
    if (!categoryName) {
      return;
    }

    this.mapHelperService.UpdateLayerGeoJson("location" + categoryName + "ActiveSource", this.mapHelperService.Empty_GeoJson);
    this.activeLayerCategoryName = null;
  }

  private loadImagesAsync() {
    this.citronellaActionsService.GetExternalImages(this.locationDTO.idLocationCategory, this.locationDTO.identifier).then(imagesResult => {
      if (imagesResult != null && imagesResult.length > 0) {
        this.images = imagesResult;
        this.isLoadingImages = false;
      } else {
        this.images = [];
        this.isLoadingImages = false;
      }
    }).catch(error => {
      this.images = [];
      this.isLoadingImages = false;
    });
  }

}
